export interface BusinessProfile {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  district: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  description: string;
  longDescription: string;
  tags: string[];
  priceRange: string;
  coverImage: string;
  logo: string;
  ownerName: string;
  ownerEmail: string;
  ownerAvatar: string;
  memberSince: string;
  isSponsored: boolean;
  isEditorPick: boolean;
  isPublished: boolean;
  rating: number;
  reviews: number;
  profileViews: number;
  openingHours: { day: string; open: string; close: string; isClosed: boolean }[];
}

export interface BusinessGalleryImage {
  id: string;
  url: string;
  alt: string;
  isCover: boolean;
  uploadedAt: string;
}

export interface BusinessSupportTicket {
  id: string;
  ticketNo: string;
  subject: string;
  category: string;
  priority: "low" | "medium" | "high";
  status: "open" | "in_progress" | "resolved" | "closed";
  createdAt: string;
  message: string;
  adminReply?: string;
}

export const businessProfile: BusinessProfile = {
  id: "kebapci-iskender",
  name: "Kebapçı İskender",
  category: "Lezzet Durakları",
  categorySlug: "food",
  district: "Osmangazi",
  address: "Atatürk Cad. 60, Osmangazi, Bursa",
  phone: "+90 224 221 4615",
  email: "info@iskender.com.tr",
  website: "www.iskender.com.tr",
  description: "1867'de icat edilen orijinal İskender Kebap'ın beşiği. Aynı aile, aynı tarif, 157 yıldır.",
  longDescription: "Kebapçı İskender, 1867 yılında İskender Efendi tarafından icat edilen ve tüm dünyaya yayılan İskender Kebap'ın orijinal mekanıdır. Dilimlenmiş kuzu eti, pide ekmeği, domates sosu ve tereyağı kombinasyonuyla hazırlanan bu eşsiz lezzet, 6. nesil tarafından aynı orijinal tarife sadık kalınarak sunulmaktadır.",
  tags: ["İskender", "Kebap", "Tarihi", "Öğle", "Orijinal"],
  priceRange: "₺₺",
  coverImage: "https://public.readdy.ai/ai/img_res/abedbcabc3e2ea7ca6a6c8ec9654bd27.jpg",
  logo: "https://readdy.ai/api/search-image?query=Iskender%20kebab%20restaurant%20logo%20emblem%20Turkish%20food%20brand%20classic%20elegant%20minimal%20warm%20circular&width=200&height=200&seq=biz_logo&orientation=squarish",
  ownerName: "Mehmet Şahin",
  ownerEmail: "info@iskender.com.tr",
  ownerAvatar: "MŞ",
  memberSince: "15.02.2025",
  isSponsored: true,
  isEditorPick: true,
  isPublished: true,
  rating: 4.8,
  reviews: 4120,
  profileViews: 28640,
  openingHours: [
    { day: "Pazartesi", open: "11:00", close: "22:00", isClosed: false },
    { day: "Salı",      open: "11:00", close: "22:00", isClosed: false },
    { day: "Çarşamba",  open: "11:00", close: "22:00", isClosed: false },
    { day: "Perşembe",  open: "11:00", close: "22:00", isClosed: false },
    { day: "Cuma",      open: "11:00", close: "23:00", isClosed: false },
    { day: "Cumartesi", open: "11:00", close: "23:00", isClosed: false },
    { day: "Pazar",     open: "11:00", close: "22:00", isClosed: false },
  ],
};

export const businessGallery: BusinessGalleryImage[] = [
  { id: "g1", url: "https://readdy.ai/api/search-image?query=iskender%20kebab%20dish%20plated%20traditional%20Turkish%20food%20grilled%20lamb%20pide%20tomato%20sauce%20butter%20presentation%20restaurant%20table%20close%20up&width=600&height=400&seq=biz_g1&orientation=landscape", alt: "İskender Tabağı", isCover: true, uploadedAt: "10.03.2026" },
  { id: "g2", url: "https://readdy.ai/api/search-image?query=Kebapci%20Iskender%20restaurant%20interior%20historic%20Bursa%20warm%20traditional%20wooden%20decor%20dining%20room%20atmosphere%20tables&width=600&height=400&seq=biz_g2&orientation=landscape", alt: "Restoran İçi", isCover: false, uploadedAt: "10.03.2026" },
  { id: "g3", url: "https://readdy.ai/api/search-image?query=iskender%20kebap%20meat%20skewer%20preparation%20traditional%20Turkish%20kitchen%20cooking%20chef%20authentic%20restaurant%20behind%20scenes&width=600&height=400&seq=biz_g3&orientation=landscape", alt: "Mutfak", isCover: false, uploadedAt: "12.03.2026" },
  { id: "g4", url: "https://readdy.ai/api/search-image?query=Turkish%20restaurant%20exterior%20historic%20building%20Bursa%20street%20facade%20stone%20Ottoman%20evening%20warm%20light%20entrance&width=600&height=400&seq=biz_g4&orientation=landscape", alt: "Dış Görünüm", isCover: false, uploadedAt: "12.03.2026" },
  { id: "g5", url: "https://readdy.ai/api/search-image?query=Turkish%20food%20table%20spread%20traditional%20meal%20appetizers%20bread%20kebab%20ayran%20yogurt%20restaurant%20setting%20full%20spread&width=600&height=400&seq=biz_g5&orientation=landscape", alt: "Sofra", isCover: false, uploadedAt: "15.03.2026" },
  { id: "g6", url: "https://readdy.ai/api/search-image?query=restaurant%20chef%20cooking%20meat%20grilling%20kebab%20Turkish%20traditional%20kitchen%20professional%20uniform%20warm%20fire&width=600&height=400&seq=biz_g6&orientation=landscape", alt: "Şef", isCover: false, uploadedAt: "18.03.2026" },
];

export const businessTickets: BusinessSupportTicket[] = [
  {
    id: "bt1", ticketNo: "#BG-1042",
    subject: "Fotoğraf yüklemede sorun yaşıyorum",
    category: "Teknik", priority: "high", status: "open",
    createdAt: "29.03.2026, 08:45",
    message: "Galeri bölümüne fotoğraf yüklemeye çalışıyorum ama hata alıyorum. Lütfen yardımcı olun.",
    adminReply: undefined,
  },
  {
    id: "bt2", ticketNo: "#BG-1035",
    subject: "Çalışma saatlerim yanlış görünüyor",
    category: "İçerik", priority: "medium", status: "resolved",
    createdAt: "20.03.2026, 11:20",
    message: "Pazar günü kapalı olarak görünüyor ama biz açığız.",
    adminReply: "Merhaba, çalışma saatlerinizi güncelledik. Kontrol edebilirsiniz.",
  },
  {
    id: "bt3", ticketNo: "#BG-1028",
    subject: "Kampanya kupon kodu yanlış görünüyor",
    category: "İçerik", priority: "low", status: "closed",
    createdAt: "14.03.2026, 09:00",
    message: "Kupon kodum sitede farklı bir değer olarak gösteriliyor.",
    adminReply: "Düzeltildi, teşekkür ederiz.",
  },
];

export const businessStats = [
  { label: "Profil Görüntüleme", value: "28.640", change: "+12% bu ay", trend: "up", icon: "ri-eye-line", color: "bg-sky-50 text-sky-700" },
  { label: "Ortalama Puan", value: "4.8", change: "4.120 yorum", trend: "up", icon: "ri-star-line", color: "bg-amber-50 text-amber-700" },
  { label: "Aktif Kampanya", value: "1", change: "Geçerli", trend: "neutral", icon: "ri-coupon-line", color: "bg-emerald-50 text-emerald-700" },
  { label: "Sponsorlu İçerik", value: "Aktif", change: "30.06.2026'ya kadar", trend: "up", icon: "ri-advertisement-line", color: "bg-violet-50 text-violet-700" },
];
